import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import "../../styles/ourServices.css";
// The cutouts already used in each service page's hero.
import eventsPng from "../../assets/images/whatwedo/eventsExperiences/events.jpg";
import influencerPng from "../../assets/images/whatwedo/influencerMarketing/influencer.png";
import celebrityPng from "../../assets/images/whatwedo/celebrityMarketing/celebrityMarketing.png";
import aiPng from "../../assets/images/whatwedo/aiContentCreation/aiContentCreation.png";

// Copy from each service page's hero. Also listed by What We Do.
export const SERVICES = [
  {
    title: "Events & Experiences", to: APP_ROUTES.EVENTS_EXPERIENCES, png: eventsPng,
    desc: "Experiences that bring brands and people together.",
    points: ["Production, vendors and logistics under one team", "Artists, celebrities and creators on the guest list", "Photos and videos captured on the day, ready to post"],
  },
  {
    title: "Influencer Marketing", to: APP_ROUTES.INFLUENCER_MARKETING, png: influencerPng,
    desc: "The right creators. The right audience. The right story.",
    points: ["Creators picked for audience fit, not follower count", "Contracts, approvals and payments handled for you", "Results reported per creator"],
  },
  {
    title: "Celebrity Marketing", to: APP_ROUTES.CELEBRITY_MARKETING, png: celebrityPng,
    desc: "Star power, with strategy behind it.",
    points: ["Film, music and sports stars matched to your brand", "Contracts, approvals and appearances handled for you", "From strategy to on-ground execution"],
  },
  {
    title: "AI Content Creation", to: APP_ROUTES.AI_CONTENT_CREATION, png: aiPng,
    desc: "Create more. Create faster. Create differently.",
    points: ["You approve the script and storyboard first", "Files sized for YouTube, Reels, feeds and posters", "Hindi, English and regional-language versions"],
  },
];

const n = SERVICES.length;
const DURATION = 4000;
const pad = (i) => String(i).padStart(2, "0");

// One service on screen at a time: its hero cutout on the left (faded into the
// background), its copy on the right. Moves on every 4s; the tabs under the
// copy show progress and jump to a service when clicked.
const OurServices = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => setActive((a) => (a + 1) % n), DURATION);
    return () => clearTimeout(timer);
  }, [active]);

  // What We Do's service links open a service here.
  useEffect(() => {
    const show = (e) => setActive(e.detail);
    window.addEventListener("our-services:show", show);
    return () => window.removeEventListener("our-services:show", show);
  }, []);

  const { title, desc, points, to } = SERVICES[active];

  return (
    <section className="osv" id="our-services">
      {/* All four visuals stack; only the active one is shown. */}
      <div className="osv-visuals" aria-hidden="true">
        {SERVICES.map((s, i) => (
          <div className={`osv-visual${i === active ? " is-active" : ""}`} key={s.title}>
            <img src={s.png} alt="" />
          </div>
        ))}
      </div>

      <div className="container osv-inner">
        <span className="osv-eyebrow">Our services</span>
        {/* Re-keyed per service so the copy fades in. */}
        <div className="osv-copy" key={active}>
          <span className="osv-count">{pad(active + 1)} / {pad(n)}</span>
          <h2>{title}</h2>
          <p className="osv-desc">{desc}</p>
          <ul className="osv-points">
            {points.map((p) => (
              <li key={p}><CircleCheck size={18} /> {p}</li>
            ))}
          </ul>
          <Link to={to} className="osv-btn">
            Explore {title} <ArrowRight size={16} />
          </Link>
        </div>

        <div className="osv-tabs">
          {SERVICES.map((s, i) => (
            <button type="button" key={s.title} className={i === active ? "is-active" : ""} onClick={() => setActive(i)}>
              <i style={{ animationDuration: `${DURATION}ms` }} />
              {s.title}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
